module.exports = __webpack_public_path__ + "media/images/lb/761-c9c711b705327e2b964ecf171d4b82d7.svg";